import { toast, ToastContainer } from 'react-toastify';
import React, { useEffect, useState } from 'react';
import logo from '../../images/logo2.svg';
import { connect } from 'react-redux';
import { createSupplier} from '../../redux/actions/Supplier/SupplierAction';
import { Link } from 'react-router-dom';

const SupplierSignUp = ({suppliers,createSupplier,history}) => {

    const [supplierName, setSupplierName] = useState('');
    const [supplierPhoneNumber,setSupplierPhoneNumber]=useState('');
    const[password,setPassword]=useState('');
    const [valid, setValid]=useState(false);
    useEffect(()=>{
        console.log(suppliers[0]);
        console.log(valid);
        if(valid){
            if(suppliers.length>0){
                const id=suppliers[0].suppliers.supplierId;
                const suppliersList=JSON.parse(localStorage.getItem('suppliersList'))||[];
                suppliersList.push({supplierPhoneNumber,password,id});
                localStorage.setItem('suppliersList',JSON.stringify(suppliersList));
                console.log(JSON.parse(localStorage.getItem('suppliersList')));
                history.push('/supplier/login');
            }
        }
    },[suppliers]);
    
    const postData=(e)=>{
        e.preventDefault();
        console.log(suppliers);
        if(supplierPhoneNumber.length!=10){
            toast.error('Enter Valid Phone Number');
        }else{
            createSupplier({
                supplierName,
                supplierPhoneNumber,
            });
            setValid(true);
        }
        console.log(suppliers);
    };

    return(
        <div>
            <section className="container-fluid maindiv mt-4">
                <div className="container formdiv d-flex shadow">
                    <img src={logo} className="formimg"></img>
                    <form className="myform" onSubmit={postData} >
                        <div className="form-group mt-2">
                            <label htmlFor="Name">User Name</label>
                            <input value={supplierName} onChange={(e) => setSupplierName(e.target.value)} type="text" className="form-control" id="exampleUserName" required/>
                        </div>
                        <div className="form-group mt-2">
                            <label htmlFor="examplePassword">Phone Number</label>
                            <input value={supplierPhoneNumber} onChange={(e) => setSupplierPhoneNumber(e.target.value)} type="number" className="form-control" id="+91 123 456 7890" required/>
                        </div>
                        <div className="form-group mt-2">
                            <label htmlFor="exampleRePassword">Password</label>
                            <input value={password} onChange={(e)=>setPassword(e.target.value)} type="password" className="form-control" id="exampleRePassword" required/>
                        </div>
                        <button type="submit" className="btn btn-primary mt-2">Register</button>
                        <p className="mt-2"><span><Link to="/supplier/login"> LogIn Here </Link></span></p>
                    </form>
                </div>
            </section>
            <ToastContainer />
        </div>
    );
};

const mapStateToProps = (state) => {
    console.log(state.suppliers);
    return{
        suppliers:state.suppliers,
    };
};
const mapDispatchToProps={createSupplier};

export default connect(mapStateToProps, mapDispatchToProps)(SupplierSignUp);
